import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { staticport } from 'src/global';
// import { StaticVariable } from 'src/app/globle.class';

@Injectable({
  providedIn: 'root'
})
export class VerticalsService {

  constructor(private httpClient : HttpClient) { }

  
    getGoogleLinkDetails():Observable<any[]>{
          const url = staticport.porturl + "GetAllForms";
          return this.httpClient.get<any[]>(url);
      } 
}
